module.exports = __webpack_public_path__ + "img/green_stars.299e992.png";